export const defaultTheme = {
    /* Basic colors*/
    /*primaryColor: '#1890ff',*/
    primaryColor: "#fea11d",
    errorColor: "#ff4d4f",
    warningColor: "#faad14",
    successColor: "#52c41a",
    infoColor: "#1890ff",

    lightColor: "#FFFFFF",
    darkColor: "#000000",

    darkHeader: "true",
    darkMenu: "false",

    fontFamily: "Cairo",

    login: null,
    logo: null,
};

export const FONTS = [
    { label: "Cairo", value: "Cairo" },
    { label: "Roboto", value: "Roboto" },
    { label: "Arial", value: "Arial" },
];
